/**
 * @file Consumer custom print configuration view.
 */

import React from 'react';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';

import CustomPrintConfiguratorContainer from '../../containers/custom-prints/CustomPrintConfiguratorContainer';
import CustomPrintsConfiguratorViewHeader from '../../components/custom-prints/CustomPrintsConfiguratorViewHeader';
import { isNativeAppWebView } from '../../../../services/native-bridge/native-apps-interface';

const CustomPrintConfigurationView = () => (
  <div className="wrapper-main content-wrap-gray">
    {!isNativeAppWebView(true) && <CustomPrintsConfiguratorViewHeader />}

    <div className="custom-prints-view-wrap">
      <CustomPrintConfiguratorContainer />
    </div>
  </div>
);

export default compose(withRouter)(CustomPrintConfigurationView);
